export default window.analytics



// WEBPACK FOOTER //
// ./src/client/misc/analytics.js